// 表格动态列配置
import { axiosPost } from "@/utils/request";

/**
 * 删除列配置
 * @param confIds 主键
 * @returns {Promise<unknown>}
 */
export const deleteColConf = (confIds) => {
  return axiosPost({
    url: "/apsFunctionColumnConf/deleteColumnConf",
    data: {
      ids: confIds,
    },
  });
};

/**
 * 查询列配置
 * @param userId 用户id
 * @param funcId 功能 id
 * @returns {Promise<unknown>}
 */
export const getColConfList = (userId, funcId) => {
  return axiosPost({
    url: "/apsFunctionColumnConf/getColumnConfList",
    data: {
      userId: userId,
      funcId: funcId,
    },
  });
};

/**
 * 新增列配置
 * @param colList 列配置列表
 * @returns {Promise<unknown>}
 */
export const insertColConf = (colList) => {
  return axiosPost({
    url: "/apsFunctionColumnConf/insertColumnConf",
    data: {
      list: JSON.stringify(colList),
    },
  });
};

/**
 * 更新列配置
 * @param colList 列配置列表
 * @returns {Promise<unknown>}
 */
export const updateColConf = (colList) => {
  return axiosPost({
    url: "/apsFunctionColumnConf/updateColumnConf",
    data: {
      list: JSON.stringify(colList),
    },
  });
};
